import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ISelectOption } from '../../../../../../../../design/inputs/select/ISelectOption';
import { IImageFilters } from '../../../imageFilters.model';
import { ImageSetType } from '../../../projectDetailsImages.model';
import { FiltersDropdownRow } from '../FiltersDropdownRow';

interface IImageSetFilterInfoProps {
  imageFilters: IImageFilters;
}

export const ImageSetFilterInfo = observer((props: IImageSetFilterInfoProps): ReactElement => {
  const { t } = useTranslator();

  const options: ISelectOption<ImageSetType>[] = Object.values(ImageSetType).map((o) => ({ label: t(`image_set_options.${o}`), value: o }));

  const selectedOptions = options.filter((d) => props.imageFilters.imageSets.includes(d.value));

  return (
    <FiltersDropdownRow
      label={t('image_filters.imageSet')}
      count={selectedOptions.length}
    >
      <>
        {selectedOptions.map((d) => (
          <div key={d.value}>{d.label}</div>
        ))}
      </>
    </FiltersDropdownRow>
  );
});
